import { RadioButtonChecked, Stop } from '@mui/icons-material'
import { Button, Typography, styled } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Webcam from 'react-webcam'
import { func, string } from 'prop-types'
import Constrols from './controls'
import DateFormat from '../../../services/DateFormat'

const StyledDiv = styled('div')`
  display: block;
  width: 100%;
  max-height: 70vh;
`

const StyledWeb = styled(Webcam)`
  height: 100%;
`
WebcamStreamCapture.propTypes = {
  onCaptureEnd: func,
  userName: string
}
export default function WebcamStreamCapture({ onCaptureEnd, userName = '' }) {
  const webcamRef = React.useRef(null)
  const mediaRecorderRef = React.useRef(null)
  const [capturing, setCapturing] = React.useState(false)
  const [recordedChunks, setRecordedChunks] = React.useState([])

  const handleStartCaptureClick = React.useCallback(() => {
    setCapturing(true)
    setRecordedChunks([])
    start()
    mediaRecorderRef.current = new MediaRecorder(webcamRef.current.stream, {
      mimeType: 'video/webm; video/mp4; video/m4v; video/MOV; video/quicktime'
    })
    mediaRecorderRef.current.addEventListener(
      'dataavailable',
      handleDataAvailable
    )
    mediaRecorderRef.current.start()
  }, [webcamRef, setCapturing, mediaRecorderRef])

  const handleDataAvailable = React.useCallback(
    ({ data }) => {
      if (data.size > 0) {
        setRecordedChunks(prev => prev.concat(data))
      }
    },
    [setRecordedChunks]
  )

  const handleStopCaptureClick = React.useCallback(() => {
    try {
      mediaRecorderRef.current.stop()
      reset()
      setCapturing(false)
    } catch (e) {
      console.error(e)
    }
  }, [mediaRecorderRef, webcamRef, setCapturing])

  const Save = React.useCallback(() => {
    if (recordedChunks.length) {
      const timestamp = DateFormat().formatar(Date.now(), 'dd-mm-yy-hours-mins')
      const blob = new File(recordedChunks, `${name}_${timestamp}.mp4`, {
        type: 'video/mp4'
      })

      onCaptureEnd(blob)
    }
  }, [recordedChunks])

  const audioConstraints = {
    suppressLocalAudioPlayback: true,
    noiseSuppression: true,
    echoCancellation: true
  }

  let cron

  const [name, setName] = useState('')

  function init() {
    setName(userName.split(' ')[0])
  }

  useEffect(() => {
    init()
  }, [])

  const [minute, setMinute] = useState(0)
  // let second = 0

  const [second, setSecond] = useState(0)

  function start() {
    pause()
    cron = setInterval(() => {
      timer()
    }, 1000)
  }

  function timer() {
    setSecond(prevSecond => {
      const aux = prevSecond + 1

      if (aux === 60) {
        setSecond(0)
        setMinute(prevMinute => {
          const minutos = prevMinute + 1
          if (minutos === 3) return handleStopCaptureClick()
          return minutos
        })
      }

      return aux
    })
  }

  function pause() {
    clearInterval(cron)
  }

  function reset() {
    setMinute(0)
    setSecond(0)
    clearInterval(cron)
  }

  function returnData(input) {
    return input > 10 ? input : `0${input}`
  }

  return (
    <StyledDiv>
      <Typography sx={{ fontSize: '1.2rem' }} color="primary">
        *Tempo máximo de gravação: 3min
      </Typography>
      <div className="d-flex">
        {/* <video style={{ width: '40%' }} controls autoPlay src={videoUrl} /> */}
        <StyledWeb
          muted={true}
          sx={{ display: 'block', width: '100%' }}
          audio={true}
          audioConstraints={audioConstraints}
          ref={webcamRef}
        />
      </div>
      <Constrols>
        {!capturing ? (
          <Button
            variant="contained"
            color="warning"
            onClick={handleStartCaptureClick}
            sx={{ padding: '0.5rem', marginTop: '0px' }}
          >
            {recordedChunks.length > 0 ? 'Gravar outro' : 'Gravar'}
            <RadioButtonChecked sx={{ ml: 1 }} />
          </Button>
        ) : (
          <Button
            onClick={handleStopCaptureClick}
            sx={{ padding: '0.5rem', marginTop: '0px' }}
            variant="contained"
            color="error"
          >
            Parar
            <Stop />
          </Button>
        )}

        {recordedChunks.length > 0 && !capturing && (
          <Button
            sx={{ padding: '0.5rem', marginTop: '0px' }}
            variant="contained"
            color="primary"
            onClick={Save}
          >
            Salvar
          </Button>
        )}
        {capturing && (
          <Typography sx={{ fontSize: '1.2rem' }} color="error">
            {returnData(minute)}:{returnData(second)}
          </Typography>
        )}
      </Constrols>
    </StyledDiv>
  )
}
